import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-modal";

import {
  certificateHolderModalOpened,
  getCertificateHolderModalState,
  certificateHolderModalClosed,
  getBinderLetterFromURL,
  getBinderLetterStatus,
  gettingBinderLetterPDFSuccess,
} from "../store/components";
import LoadingSpinner from "./BinderLoading";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CancelIcon from "@material-ui/icons/Cancel";
import * as theme from "../theme";
import { makeStyles } from "@material-ui/core/styles";
import { useState, useEffect } from "react";
import { getCoverIdForExpiryDate } from "../store/businesslogic/hardwiredlogic";
import moment from "moment";
import ReactLoading from "react-loading";
import Select from "react-dropdown-select";

import {
  getBinderDetails,
  getEncryCRSProspectIdFromMyBinders,
  getSelectedBinderDetails,
} from "../store/mybinder";
import {
  addCertificateHolder,
  getAddCertificateHolderResponse,
  allCertificateHolderList,
} from "../store/certificate";
import { getBrokerInformation } from "../store/broker";
import { ImportantDevices, LabelImportant } from "@material-ui/icons";
import { PossibleApiStatusValues } from "../store/helperfuncs";
import translations from "../utils/translations";
const AddCertificateHolder = (props) => {
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;
  const certificateTranslations =
    translations[languagepreference].addCertificateHolderModal;
  const dispatch = useDispatch();
  const certificateHolderModalState = useSelector(
    getCertificateHolderModalState
  );
  const addcertificateResponceData = useSelector(
    getAddCertificateHolderResponse
  );
  const [nameError, setNameError] = useState("");
  const [countryError, setCountryError] = useState("");
  const [PostalCodeError, setPostalCodeError] = useState("");
  const [provinceError, setProvinceError] = useState("");
  const [streetError, setStreetError] = useState("");
  const [streetNumError, setStreetNumError] = useState("");
  const [cityError, setCityError] = useState("");
  const [natureError, setNatureError] = useState("");
  const [locationError, setLocationError] = useState("");
  const [waiverError, setwaiverError] = useState("");
  const [noticeError, setNoticeError] = useState("");

  const [coverinfo, setCoverInfo] = useState([]);
  const [allcovers, setAllCovers] = useState([]);
  const [coversasis, setAllCoversasis] = useState({});
  const [coverTypes, setCoverTypes] = useState("");
  const [binderLetter, setBinderLetter] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [clientInformation, setClientInformation] = useState([]);
  const [returnCover, setReturnCover] = useState({
    coverValue: "",
  });
  const [show, setShow] = useState(false);
  const [values, setValues] = useState({});
  const [storeBinder, setStoreBinder] = useState({
    policyid: "",
    holderName: "",
    natureOfInterest: "",
    locationOfInterest: "",
    noticeRequired: "",
    holderCountry: "",
    holderPostalcode: "",
    holderProvince: "",
    holderStreet: "",
    holderStreetNumber: "",
    isAdditionalInsured: false,
    isLossPayee: false,
    holderTown: "",
    crossLiability: false,
    waiverOfSubrogation: false,
  });

  const useStyles = makeStyles(
    theme.customMaterialUIClassForScrollBarDarkBackgrond
  );

  const binderLetterStatus = useSelector(getBinderLetterStatus);

  const prospectidEncryCRS = useSelector(getEncryCRSProspectIdFromMyBinders());

  const storeCertificateDetails = async () => {
    // dispatch(certificateHolderModalClosed());
    const storeCertificateDetails = { ...storeBinder };
    const addHolderData = {
      policyid: props && props.binderId,
      additionalinsurers: {
        interestname: storeCertificateDetails.holderName,
        isAdditionalInsured: storeCertificateDetails.isAdditionalInsured,
        isLossPayee: storeCertificateDetails.isLossPayee,
        isCertificateHolder: true,
        address: {
          city: storeCertificateDetails.holderTown,
          addr_line1: storeCertificateDetails.holderStreet,
          addr_line2: storeCertificateDetails.holderStreetNumber,
          postal_code: storeCertificateDetails.holderPostalcode,
          province: storeCertificateDetails.holderProvince,
          country: storeCertificateDetails.holderCountry,
        },
        interestnature:
          storeCertificateDetails.isAdditionalInsured === false &&
          storeCertificateDetails.isLossPayee === false
            ? null
            : storeCertificateDetails.natureOfInterest,
        noticerequireddays:
          storeCertificateDetails.isAdditionalInsured === false &&
          storeCertificateDetails.isLossPayee === false
            ? null
            : storeCertificateDetails.noticeRequired,
        subrogationwaiverrequired:
          storeCertificateDetails.isAdditionalInsured === false &&
          storeCertificateDetails.isLossPayee === false
            ? null
            : storeCertificateDetails.waiverOfSubrogation,
        crossliability:
          storeCertificateDetails.isAdditionalInsured === false &&
          storeCertificateDetails.isLossPayee === false
            ? null
            : storeCertificateDetails.crossLiability,
        locationofinterest:
          storeCertificateDetails.isAdditionalInsured === false &&
          storeCertificateDetails.isLossPayee === false
            ? null
            : storeCertificateDetails.locationOfInterest,
      },
    };
    if (storeBinder.holderName === "") {
      setNameError("Please fill this field");
    } else if (storeBinder.holderName === "") {
      setNameError("Please fill this field");
    } else {
      dispatch(addCertificateHolder(addHolderData)).then(() => {
        dispatch(certificateHolderModalClosed());
        dispatch(allCertificateHolderList(props.binderId));
        toast.success(addcertificateResponceData.message);
      });
    }
  };

  const option = [
    { value: "Loss Payee", label: certificateTranslations.lossPayee },
    {
      value: "Additional Insured",
      label: certificateTranslations.additionalInsured,
    },
    { value: "NO", label: certificateTranslations.no },
  ];
  const handleChecked = (checkbox, id) => {
    const isSelected = selectedItems
      .map((item) => {
        if (item.key === id.toString()) {
          return id.toString();
        }
      })
      .indexOf(id.toString());

    if (checkbox.target.checked) {
      selectedItems.push({
        key: id.toString(),
        value: coversasis[id].toString(),
      });
    } else {
      selectedItems.splice(isSelected, 1);
    }
  };
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  const getCoversasisValue = (id) => {
    let returnValue = "";
    let coversasisvalue = coversasis ? coversasis?.[id] : "-";
    if (!coversasisvalue) return null;
    if (id === getCoverIdForExpiryDate()) {
      returnValue =
        coversasisvalue &&
        moment(new Date(coversasisvalue)).format("DD MMM YYYY");
    } else if (isNaN(coversasisvalue)) {
      returnValue = coversasisvalue + "";
    } else {
      if (coversasisvalue > 0 && coversasisvalue <= 2) {
        returnValue = coversasisvalue * 100 + "%";
      } else {
        returnValue = formatter.format(coversasisvalue);
      }
    }
    return returnValue;
  };
  const handleCoverChange = (event, id) => {
    let returnValue = "";
    let coversasisvalue = { ...coversasis };
    coversasisvalue[id] = event.target.value;
    setAllCoversasis(coversasisvalue);
  };

  const style = {
    minHeight: "2vh",
    fontSize: "1.8vmin",
    fontFamily: "GibsonRegular",
  };
  const inputStyle = {
    marginLeft: "-57%",
    borderRadius: "10px",
    border: "0px",
    width: "163%",
    lineHeight: "39px",
    marginBottom: "14px",
    marginTop: "-4px",
    padding: "0 10px",
  };

  const handleCloseButton = () => {
    dispatch(certificateHolderModalClosed());
  };

  const classes = useStyles();

  const heights = {
    desc: "8%",
    proceedbutton: "8%",
    somegapbetween: "2%",
    remainingHeight: "",
  };

  const hDist = {
    headingHeight: "10%",
    remainingHeight: "10%",
  };

  hDist.remainingHeight = `calc(100% - ${hDist.headingHeight})`;

  heights.remainingHeight = `calc(100% - ${heights.desc} - ${heights.proceedbutton} - ${heights.somegapbetween})`;
  const handleCertificateHolder = (event) => {
    setNameError("");
    const temp = { ...storeBinder };
    temp.holderName = event.target.value;
    temp.policyid = props.binderId;
    setStoreBinder(temp);
  };

  const certificateHolder = () => {
    dispatch(certificateHolderModalOpened());
  };
  const handleClientNameChange = (event) => {
    const temp = { ...storeBinder };
    temp.clientName = event.target.value;
    setStoreBinder(temp);
  };
  return (
    <>
      <CommonModalForConfiguration
        heading={certificateTranslations.addCertificateHolder}
        subHeading={certificateTranslations.fromHereCustomizeDetails}
        handleCloseButton={handleCloseButton}
        classes={classes}
        heights={heights}
        hDist={hDist}
        storeCertificateDetails={storeCertificateDetails}
        binderLetterStatus={binderLetterStatus}
      >
        <div className="mt-4"></div>
        <CommonHeading
          text={certificateTranslations.certificateHolderInformation}
        ></CommonHeading>
        <CommonInputField
          label={certificateTranslations.certificateHolderName}
          placeholder={certificateTranslations.certificateHolderName}
          onChange={handleCertificateHolder}
          value={storeBinder ? storeBinder.holderName : null}
        ></CommonInputField>
        {nameError ? (
          <small
            style={{
              color: "red",
              marginLeft: "30%",
            }}
          >
            {nameError}
          </small>
        ) : null}
        <CommonInputField
          label={certificateTranslations.addressLine1}
          placeholder={certificateTranslations.addressLine1}
          onChange={(event) => {
            setStreetError("");
            const temp = { ...storeBinder };
            temp.holderStreet = event.target.value;
            setStoreBinder(temp);
          }}
        ></CommonInputField>
        <CommonInputField
          label={certificateTranslations.addressLine2}
          placeholder={certificateTranslations.addressLine2}
          onChange={(event) => {
            setStreetNumError("");
            const temp = { ...storeBinder };
            temp.holderStreetNumber = event.target.value;
            setStoreBinder(temp);
          }}
        ></CommonInputField>
        <CommonInputField
          label={certificateTranslations.townCity}
          placeholder={certificateTranslations.townCity}
          onChange={(event) => {
            setCityError("");
            const temp = { ...storeBinder };
            temp.holderTown = event.target.value;
            setStoreBinder(temp);
          }}
        ></CommonInputField>
        <CommonInputField
          label={certificateTranslations.province}
          placeholder={certificateTranslations.province}
          onChange={(event) => {
            setProvinceError("");
            const temp = { ...storeBinder };
            temp.holderProvince = event.target.value;
            setStoreBinder(temp);
          }}
        ></CommonInputField>
        <CommonInputField
          label={certificateTranslations.postalCode}
          placeholder={certificateTranslations.postalCode}
          onChange={(event) => {
            setPostalCodeError("");
            const temp = { ...storeBinder };
            temp.holderPostalcode = event.target.value;
            setStoreBinder(temp);
          }}
        ></CommonInputField>
        <CommonInputField
          label={certificateTranslations.country}
          placeholder={certificateTranslations.country}
          onChange={(event) => {
            setCountryError("");
            const temp = { ...storeBinder };
            temp.holderCountry = event.target.value;
            setStoreBinder(temp);
          }}
        ></CommonInputField>
        <CommonInputField
          label={certificateTranslations.numberOfDaysNoticeRequiredQuestion}
          placeholder={certificateTranslations.numberOfDaysNoticeRequired}
          onChange={(event) => {
            const temp = { ...storeBinder };
            temp.noticeRequired = event.target.value;
            setStoreBinder(temp);
          }}
        ></CommonInputField>

        <div style={{ height: "2vh" }}></div>

        <section
          style={{
            minHeight: "8vh",
            width: "100%",
            display: "flex",
            alignItems: "center",
            paddingTop: " 2vh",
          }}
        >
          <div
            style={{
              width: "30%",
              paddingLeft: "7vmin",
              height: "100%",
              display: "flex",
              alignItems: "flex-start",
            }}
          >
            {certificateTranslations.lossPayeeOrAdditionalInsuredQuestion}
          </div>
          <div style={{ width: "50%", minHeight: "100%" }}>
            <select
              name="Select "
              className="form-select"
              style={{
                width: "100%",
                height: "100%",
                padding: "2vmin",
                color: theme.COLORS.dark_navy_blue,
                border: `2px solid ${theme.COLORS.secondary_skyblue}`,
                borderRadius: 5,
                letterSpacing: 1.2,
                backgroundColor: theme.COLORS.tertiary_ligthindigo,
              }}
              onChange={(event) => {
                if (event.target.value === "NO") {
                  setShow(false);
                  const temp = { ...storeBinder };
                  temp.isAdditionalInsured = false;
                  temp.isLossPayee = false;
                  setStoreBinder(temp);
                } else {
                  setShow(true);
                  if (event.target.value === "Additional Insured") {
                    const temp = { ...storeBinder };
                    temp.isAdditionalInsured = true;
                    temp.isLossPayee = false;
                    setStoreBinder(temp);
                  } else if (event.target.value === "Loss Payee") {
                    const temp = { ...storeBinder };
                    temp.isLossPayee = true;
                    temp.isAdditionalInsured = false;
                    setStoreBinder(temp);
                  }
                }
              }}
              aria-label="Default select example"
              required
            >
              <option selected>
                {certificateTranslations.selectYourOption}
              </option>
              {option &&
                option.map((item, i) => (
                  <option value={item.value}>{item.label} </option>
                ))}
            </select>
          </div>
        </section>
        {show ? (
          <>
            <CommonInputField
              label={certificateTranslations.natureOfInterest}
              placeholder={certificateTranslations.natureOfInterest}
              onChange={(event) => {
                const temp = { ...storeBinder };
                temp.natureOfInterest = event.target.value;
                setStoreBinder(temp);
              }}
            ></CommonInputField>
            <CommonInputField
              label={certificateTranslations.locationOfInterest}
              placeholder={certificateTranslations.locationOfInterest}
              onChange={(event) => {
                const temp = { ...storeBinder };
                temp.locationOfInterest = event.target.value;
                setStoreBinder(temp);
              }}
            ></CommonInputField>
            <section
              style={{
                minHeight: "8vh",
                width: "100%",
                display: "flex",
                alignItems: "center",
                paddingTop: "2vh",
              }}
            >
              <div
                style={{
                  width: "30%",
                  paddingLeft: "7vmin",
                  height: "100%",
                  display: "flex",
                  alignItems: "flex-start",
                }}
              >
                {certificateTranslations.waiverOfSubrogationRequiredQuestion}
              </div>
              <div style={{ width: "50%", minHeight: "100%" }}>
                <div className="d-flex">
                  <div class="custom-control custom-radio ml-5">
                    <input
                      class="custom-control-input"
                      type="radio"
                      name="customRadio12"
                      id="customRadioption1"
                      value={true}
                      onChange={(event) => {
                        const temp = { ...storeBinder };
                        temp.waiverOfSubrogation = event.target.checked;
                        setStoreBinder(temp);
                      }}
                    />
                    <label class="custom-control-label" for="customRadioption1">
                      {certificateTranslations.yes}
                    </label>
                  </div>
                  <div class="custom-control custom-radio ml-5">
                    <input
                      class="custom-control-input"
                      type="radio"
                      name="customRadio12"
                      id="customRadio22"
                      value={false}
                      onChange={(event) => {
                        const temp = { ...storeBinder };
                        temp.waiverOfSubrogation = !event.target.checked;
                        setStoreBinder(temp);
                      }}
                    />
                    <label class="custom-control-label" for="customRadio22">
                      {certificateTranslations.no}
                    </label>
                  </div>
                </div>
              </div>
            </section>
            <section
              style={{
                minHeight: "8vh",
                width: "100%",
                display: "flex",
                alignItems: "center",
                paddingTop: "2vh",
              }}
            >
              <div
                style={{
                  width: "30%",
                  paddingLeft: "7vmin",
                  height: "100%",
                  display: "flex",
                  alignItems: "flex-start",
                }}
              >
                {certificateTranslations.crossLiabilityClauseRequiredQuestion}
              </div>
              <div style={{ width: "50%", minHeight: "100%" }}>
                <div className="d-flex">
                  <div class="custom-control custom-radio ml-5 ">
                    <input
                      class="custom-control-input"
                      type="radio"
                      name="customRadio1"
                      id="customRadio1"
                      value={true}
                      onChange={(event) => {
                        const temp = { ...storeBinder };
                        temp.crossLiability = event.target.checked;
                        setStoreBinder(temp);
                      }}
                    />
                    <label class="custom-control-label" for="customRadio1">
                      {certificateTranslations.yes}
                    </label>
                  </div>
                  <div class="custom-control custom-radio ml-5">
                    <input
                      class="custom-control-input"
                      type="radio"
                      name="customRadio1"
                      id="customRadio2"
                      value={false}
                      onChange={(event) => {
                        const temp = { ...storeBinder };
                        temp.crossLiability = !event.target.checked;
                        setStoreBinder(temp);
                      }}
                    />
                    <label class="custom-control-label" for="customRadio2">
                      {certificateTranslations.no}
                    </label>
                  </div>
                </div>
              </div>
            </section>
          </>
        ) : null}
      </CommonModalForConfiguration>
    </>
  );
};

const CommonHeading = ({ text }) => {
  return (
    <section
      style={{
        width: "100%",
        height: "4vh",
        fontSize: "2.2vmin",
        color: theme.COLORS.secondary_skyblue,
        display: "flex",
        alignItems: "center",
      }}
    >
      {text}
    </section>
  );
};
const CommonInput = ({
  label = "Sample label",
  onChange,
  value,
  placeholder,
}) => {
  return (
    <section
      style={{
        minHeight: "8vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        paddingTop: "2vh",
      }}
    >
      <div
        style={{
          width: "30%",
          paddingLeft: "7vmin",
          height: "100%",
          display: "flex",
          alignItems: "flex-start",
        }}
      >
        {label}
      </div>
      <div style={{ width: "50%", minHeight: "100%" }}>
        <textarea
          style={{
            width: "100%",
            height: "100%",
            padding: "2vmin",
            color: theme.COLORS.dark_navy_blue,
            border: `2px solid ${theme.COLORS.secondary_skyblue}`,
            borderRadius: 5,
            letterSpacing: 1.2,
            backgroundColor: theme.COLORS.tertiary_ligthindigo,
          }}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          // onBlur={handleBlur}
          // value={reason}
        ></textarea>
      </div>
    </section>
  );
};
const CommonInputField = ({
  label = "Sample common label",
  onChange,
  value,
  placeholder,
  required,
}) => {
  return (
    <section
      style={{
        minHeight: "8vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        paddingTop: "2vh",
      }}
    >
      <div
        style={{
          width: "30%",
          paddingLeft: "7vmin",
          height: "100%",
          display: "flex",
          alignItems: "flex-start",
        }}
      >
        {label}
      </div>
      <div style={{ width: "50%", minHeight: "100%" }}>
        <input
          style={{
            width: "100%",
            height: "100%",
            padding: "2vmin",
            color: theme.COLORS.dark_navy_blue,
            border: `2px solid ${theme.COLORS.secondary_skyblue}`,
            borderRadius: 5,
            letterSpacing: 1.2,
            backgroundColor: theme.COLORS.tertiary_ligthindigo,
          }}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          // onBlur={handleBlur}
          // value={reason}
        ></input>
      </div>
    </section>
  );
};

const CommonModalForConfiguration = ({
  heading,
  subHeading,
  handleCloseButton,
  classes,
  heights,
  hDist,
  children,
  storeCertificateDetails,
  binderLetterStatus,
}) => {
  const dispatch = useDispatch();
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;
  const certificateTranslations =
    translations[languagepreference].addCertificateHolderModal;
  useEffect(() => {
    const onKeyPressed = (e) => {
      if (e.keyCode === 27) {
        dispatch(certificateHolderModalClosed());
      }
    };
    document.addEventListener("keydown", onKeyPressed);

    return () => {
      document.removeEventListener("keydown", onKeyPressed);
    };
  }, [dispatch]);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
      }}
    >
      <div
        style={{
          height: hDist.headingHeight,
          width: "100%",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: theme.COLORS.secondary_skyblue,
            fontSize: "1.9vmin",
            letterSpacing: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "white",
            fontFamily: "GibsonRegular",
          }}
        >
          {heading}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: hDist.remainingHeight,
          backgroundColor: theme.COLORS.primary_navyblue,
          padding: "2vmin",
          paddingTop: 0,
        }}
      >
        <div style={{ position: "absolute", top: 0, right: 0 }}>
          <CancelIcon
            fontSize="large"
            style={{ cursor: "pointer", color: "white" }}
            onClick={handleCloseButton}
          ></CancelIcon>
        </div>

        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            color: "white",
            fontFamily: "GibsonRegular",
          }}
        >
          <div
            style={{
              width: "100%",
              height: heights.desc,
              fontSize: "1.7vmin",
              letterSpacing: 1,
              fontFamily: "GibsonLight",
              padding: "2vmin",
              paddingLeft: 0,
            }}
          >
            {subHeading}
          </div>

          <div
            style={{
              width: "100%",
              height: heights.remainingHeight,
              fontSize: "1.9vmin",
              letterSpacing: 1,
              overflow: "auto",
            }}
            className={classes.responses}
          >
            {children}
          </div>
          <div
            style={{
              width: "100%",
              height: heights.somegapbetween,
            }}
          ></div>
          <div
            style={{
              width: "100%",
              height: heights.proceedbutton,
              backgroundColor: theme.COLORS.secondary_orange,
              fontSize: "1.9vmin",
              letterSpacing: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 10,
              cursor: "Pointer",
            }}
            onClick={() => {
              storeCertificateDetails();
            }}
          >
            <div>{certificateTranslations.save}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCertificateHolder;
